var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"config-dynamic-input",style:(_vm.inputStyle),attrs:{"type":"number","placeholder":"content..."},domProps:{"value":_vm.value},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }